// extracted by mini-css-extract-plugin
module.exports = {"text":"PremiumMember-module_text_dcA2D","wrapper":"PremiumMember-module_wrapper_dkD5s","icon":"PremiumMember-module_icon_2yHvO"};